import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { AppSteps, StepsManagementService } from '../../shared/services/steps-management.service';
import { map, Observable } from 'rxjs';
import { PcaStatusService } from '../../shared/services/pca-status.service';
import { ROUTER_PATHS } from '../../app.const';
import { EnvironmentService } from '../../environment/environment.service';
import { NavigationService } from '@pc/shared';

@Injectable({
  providedIn: 'root'
})
export class ManualNavigationGuard implements CanActivate {
  private stepsManagementService = inject(StepsManagementService);
  private navigationService = inject(NavigationService);
  private statusService = inject(PcaStatusService);
  private enviromentService = inject(EnvironmentService);

  public canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const routePath = route.routeConfig?.path || '';
    const apiUrl = this.enviromentService.environment.url.apiUrl;
    return this.statusService.getProcessStatus(apiUrl).pipe(
      map((isActive) => {
        if (!isActive) {
          return this.handleInactiveAccess(routePath);
        }

        return this.handleStepAccess(routePath);
      })
    );
  }

  private handleInactiveAccess(route: string): boolean {
    const isUnderConstructionPath = route === ROUTER_PATHS.UNDER_CONSTRUCTION;

    if (!isUnderConstructionPath) {
      this.navigationService.navigateByUrl(ROUTER_PATHS.UNDER_CONSTRUCTION);
      return false;
    }

    return true;
  }

  private handleStepAccess(route: string): boolean {
    const isUnderConstructionPath = route === ROUTER_PATHS.UNDER_CONSTRUCTION;

    if (this.stepsManagementService.isStepLocked(route) || isUnderConstructionPath) {
      this.stepsManagementService.navigateToStep(AppSteps.TripDetails);
      return false;
    }

    return true;
  }
}
